module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "encerramentoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "encerramentoModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Entendi",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "encerramentoModalLabel"
    }
  }, [_vm._v("\n            Atualização  do CPF do Familiar\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 aviso-inicial"
  }, [_vm._v("\n              \"Conforme portaria 06/2022-SEGES, o recadastramento encerrou dia 05/08/2022.\n              Excepcionalmente, será permitido que os servidores atualizem os dados até 23:59 do dia 07/08/2022\"\n            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-778e480a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dependente-cpf/encerramento-modal.vue
// module id = UAGg
// module chunks = 5